import { render, staticRenderFns } from "./CompanyDataUpdateForms.vue?vue&type=template&id=949399b8&scoped=true&"
import script from "./CompanyDataUpdateForms.vue?vue&type=script&lang=js&"
export * from "./CompanyDataUpdateForms.vue?vue&type=script&lang=js&"
import style0 from "./CompanyDataUpdateForms.vue?vue&type=style&index=0&id=949399b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "949399b8",
  null
  
)

export default component.exports